<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_entidade"
                        :options="optionsTpEntidade"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Entidade"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_chamada"
                        :options="optionsTpChamada"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Chamada"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_fluxo"
                        :options="optionsTpFluxo"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Fluxo"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="layout"
                        :options="optionsLayout"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Layout"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
      Multiselect
  },
  props: {
    tabela: '',
  },
  data () {
    return {
      helpForm: new Form({params: []}),
      descr: '',
      optionsStatus: [],
      optionsLayout: [],
      optionsTpFluxo: [],
      optionsTpChamada: [],
      optionsTpEntidade: [],
      status: [],
      tp_chamada: [],
      tp_entidade: [],
      tp_fluxo: [],
      layout: [],
      data_filter: []
    }
  },
  mounted() {
      this.getLivGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {
                              descr: this.descr,
                              tp_chamada: this.tp_chamada,
                              tp_fluxo: this.tp_fluxo,
                              tp_entidade: this.tp_entidade,
                              layout: this.layout,
                              status: this.status}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.descr = '';
        this.status = '';
        this.tp_chamada = '';
        this.tp_entidade = '';
        this.tp_fluxo = '';
        this.layout = '';
        this.$events.fire('filter-reset');
      },
      getLivGeral()
      {
          this.helpForm.get('/api/interfacegateway/jsonlistgeral').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.tp_chamada.forEach((obj)=>
              {
                  this.optionsTpChamada.push({ label: obj.descr, value: obj.valor })
              })
              response.tp_entidade.forEach((obj)=>
              {
                  this.optionsTpEntidade.push({ label: obj.descr, value: obj.valor })
              })
              response.tp_fluxo.forEach((obj)=>
              {
                  this.optionsTpFluxo.push({ label: obj.descr, value: obj.valor })
              })
              response.status.forEach((obj)=>
              {
                  this.optionsStatus.push({ label: obj.descr, value: obj.valor })
              })
              response.layout.forEach((obj)=>
              {
                  this.optionsLayout.push({ label: obj.descr, value: obj.lay_id })
              })

          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
